/**
 * In-memory session profile. Authorization decisions must use this store,
 * not localStorage (which is trivially tampered in DevTools).
 */

const EMPTY_SESSION = {
  email: '',
  role: '',
  accountType: '',
  allowUserAppOnWeb: false,
  allowAccessWithoutPayment: false,
  canAccessRobots: false,
  subscriptionAdmin: null,
};

let session = { ...EMPTY_SESSION };
const listeners = new Set();

export function getSession() {
  return { ...session };
}

export function setSession(partial) {
  session = { ...session, ...partial };
  listeners.forEach((fn) => fn(getSession()));
}

export function clearSession() {
  session = { ...EMPTY_SESSION };
  listeners.forEach((fn) => fn(getSession()));
}

export function subscribeSession(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getUserRole() {
  return (session.role ?? '').toString().trim();
}

export function getAccountType() {
  return (session.accountType ?? '').toString().trim();
}

export function getUserEmail() {
  return (session.email ?? '').toString().trim();
}

export function getSubscriptionAdmin() {
  return session.subscriptionAdmin || null;
}

export function canAccessSubscriptionAdmin() {
  return Boolean(session.subscriptionAdmin);
}

export function getApiPrefix() {
  return getSubscriptionAdmin()?.apiPrefix || '/api/v1/subscription-admin';
}
